<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="_idContainer000">
<p class="pl-title"><a id="_idTextAnchor000"></a>Winnie Griggs<br/>and<br/>Regina Scott</p>
<p class="pl-author">Texas Cinderella<br/>&amp;<br/>Would-Be Wilderness Wife</p>
<p class="pl-logo"><span class="bold"><img alt="logo" height="70" src="image/LI_2020.png"/></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?4f774166